export default __webpack_public_path__ + "static/media/checkmark.17b5662c.svg";